<script>
  import { onMount } from "svelte";
  import { getWrittenName } from "../../utils/utilities";
  import { createEventDispatcher } from "svelte";

  export let options = [];
  export let selected = ""; // string separado por delimitador
  export let dataObject = [];
  export let label = "";
  export let placeholder = "Select options";
  export let isError = false;
  export let delimiter = "||";
  export let isChatForm = false;

  let isOpen = false;
  let selectedArray = [];

  $: if (selected === "") {
    selectedArray = [];
  }

  const dispatch = createEventDispatcher();

  onMount(() => {
    if (selected) {
      selectedArray = selected.split(delimiter);
    }
  });

  function toggleOption(option) {
    const idx = selectedArray.indexOf(option);
    if (idx === -1) {
      selectedArray = [...selectedArray, option];
    } else {
      selectedArray = selectedArray.filter((o) => o !== option);
    }
    selected = selectedArray.join(delimiter);
  }

  function isSelected(option) {
    return selectedArray.includes(option);
  }

  function toggleDropdown() {
    isOpen = !isOpen;
  }

  function closeDropdown(e) {
    if (!e.target.closest(".multi-select-wrapper")) {
      isOpen = false;
    }
  }

  function send() {
    const finalValue = selectedArray.join(delimiter);
    dispatch("message", finalValue);
  }

  // Cerrar al hacer clic fuera
  onMount(() => {
    window.addEventListener("click", closeDropdown);
    return () => window.removeEventListener("click", closeDropdown);
  });
</script>

<div class="multi-select-wrapper">
  <div class="multi-select-dropdown">
    <div class="multi-select-trigger {isError ? 'error-border' : ''}" role="button" tabindex="0" on:click={toggleDropdown}>
      {#if selectedArray.length > 0}
        {#each selectedArray as v}
          <span class="badge">{getWrittenName(v, dataObject)}</span>
        {/each}
      {:else}
        <span class="placeholder">--{placeholder}--</span>
      {/if}
      <span class="dropdown-icon">▾</span>
    </div>

    {#if isOpen}
      <div class="multi-select-options">
        {#each options as option}
          <label class="multi-select-option">
            <input type="checkbox" checked={isSelected(option)} on:change={() => toggleOption(option)} />
            <span>{getWrittenName(option, dataObject)}</span>
          </label>
        {/each}
      </div>
    {/if}
  </div>
  {#if isChatForm}
    <button on:click={send} class="chatwith-chat-sendbutton">
      <svg style="width: 18px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          fill="currentColor"
          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
        />
      </svg>
    </button>
  {/if}
</div>

<style>
  .multi-select-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: start;
    gap: 10px;
  }

  .multi-select-dropdown {
    flex: 1;
    max-width: 100%;
  }

  .chatwith-chat-sendbutton {
    border: none;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color);
    color: white;
    cursor: pointer;
    flex-shrink: 0;
  }

  .multi-select-trigger {
    box-sizing: border-box;
    border: 1px solid #ccc;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    background: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    min-height: 35px;
    position: relative;
  }

  .dropdown-icon {
    margin-left: auto;
    font-size: 12px;
    color: #999;
  }

  .badge {
    background-color: #f0f0f0;
    color: #333;
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 13px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .multi-select-trigger:hover {
    border-color: #999;
  }

  .placeholder {
    color: #999;
  }

  .multi-select-options {
    position: relative;
    background: white;
    border: 1px solid #ccc;
    z-index: 999;
    width: 100%;
    max-height: 220px;
    overflow-y: auto;
    margin-top: 4px;
    border-radius: 4px;
    font-size: 14px;
  }

  .multi-select-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    cursor: pointer;
  }

  .multi-select-option:hover {
    background: #f3f3f3;
  }

  .multi-select-option input {
    width: auto !important;
    min-height: 0 !important;
  }

  .error-border {
    border-color: red;
  }
</style>
